import React from "react";
import Profile from "./Profile";
import Skills from "./Skills";
import Experience from "./Experience";
import Personal_Projects from "./Personal_Projects";


function Right() {
  return (
    <div className="right-side">
      <Profile />
      <Experience />
     
    </div>
  )
}

export default Right;